import { useEffect } from 'react';

import { WebSocketEntityType } from '@this+that/models';
import log from 'loglevel';

import {
  useWebSocket,
  WebSocketEventType,
} from '../../context/WebSocket/WebSocketContext';
import { useFetchCacheStore } from '../../store';
import { indexedDBAdapter } from '../../store/utils/indexedDBAdapter';

export const useOnReconnect = () => {
  const { subscribe } = useWebSocket();
  const { clearCache } = useFetchCacheStore();

  useEffect(() => {
    const unsubscribeUserComm = subscribe(
      WebSocketEntityType.UserCommunication,
      WebSocketEventType.RECONNECT_AFTER_LONG_PAUSE,
      async () => {
        log.info(
          '[useOnReconnect] Reconnected after long pause - clearing caches',
        );
        clearCache();
        await indexedDBAdapter.cleanupDeletedItems();
      },
    );

    const unsubscribeInbox = subscribe(
      WebSocketEntityType.InboxEntry,
      WebSocketEventType.RECONNECT_AFTER_LONG_PAUSE,
      () => {
        log.debug('[useOnReconnect] InboxEntry reconnect event received');
      },
    );

    return () => {
      unsubscribeUserComm();
      unsubscribeInbox();
    };
  }, [subscribe, clearCache]);
};
